// reducers/employee-onboarding/responses.js

// responses

export function responsesHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_RESPONSES_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function responsesIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_RESPONSES_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function responses(state = [], action) {
  switch (action.type) {
    case 'ONBOARDING_RESPONSES_FETCH_DATA_SUCCESS':
      return action.list;
    default:
      return state;
  }
}

// responses_add

export function responsesAddHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_RESPONSES_ADD_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function responsesAddIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_RESPONSES_ADD_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function responsesAdd(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_RESPONSES_ADD_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}

// responses_delete

export function responsesDeleteHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_RESPONSES_DELETE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function responsesDeleteIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_RESPONSES_DELETE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function responsesDelete(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_RESPONSES_DELETE_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}